// @owners { team: patients }
export enum CategorySearch {
  Search = -2,
  All = -1,
}
